// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"472":"cb58c467","539":"29c16d63"}[chunkId] + ".chunk.css";
};